import styled from 'styled-components';

interface CircleProps {
  $colorName: string;
  $diameter?: string;
}

export const Circle = styled.div<CircleProps>`
  cursor: pointer;
  background: ${props => props.$colorName};
  border-radius: 50%;
  width: ${props => props.$diameter};
  height: ${props => props.$diameter};
`;

export const ActiveCircle = styled.div<CircleProps>`
  position: relative;
  border-radius: 50%;
  border: 3px solid;
  border-color: ${({ $colorName }) => $colorName};
  width: ${props => props.$diameter};
  height: ${props => props.$diameter};

  &::after {
    background: ${({ $colorName }) => $colorName};
    content: '';
    position: absolute;
    top: 3px;
    right: 3px;
    bottom: 3px;
    left: 3px;
    border-radius: 50%;
  }
`;
